// extracted by mini-css-extract-plugin
module.exports = {"header":"aVWIkw6msdzhXNQ0PMZa"};